// BS4 modal handling

var fn_modal_bs = function () {

  // BS4 MODAL
  // > aria hidden handling fix + focus on close btn + overflow on body
  $('.modal').on('shown.bs.modal', function () {
    $(this).attr('aria-hidden', 'false');
    $(this).children().find('.close').focus();
    $("body").addClass("modal-open");
  }).on('hidden.bs.modal', function (e) {
    $(this).attr('aria-hidden', 'true');
    $("body").removeClass("modal-open");
  });

  // > modal must have a backdrop inside its Fixed positioned container
  $('.js-backdrop-moved').on('shown.bs.modal', function () {
    $(".modal-backdrop").clone().appendTo(".main");
    $("body > .modal-backdrop").remove();
  }).on('hidden.bs.modal', function (e) {
    $(".modal-backdrop").remove();
  });

};
